import { replace } from 'connected-react-router';

import { withPreconditions } from 'src/app/hocs/withPreconditions';
import { medications } from 'src/app/router/paths';
import { getCurrentCartId } from 'src/app/state/selectors';
import type { Dispatch, RootState } from 'src/app/state/store';

export const requiresInCheckout = withPreconditions(
  (state: RootState) => {
    return !!getCurrentCartId(state);
  },
  async (dispatch: Dispatch) => {
    return dispatch(replace(medications.toPath()));
  }
);
